// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {hasAccess} from '../../../../shared/services/security';
import {hasPermission} from '../../../../shared/services/privacy';

function handleRegisterAnother() {

    this.handleSubmit(true);

}

function handleSaveExistingRegistration() {

    this.handleSubmit(false, true);

}

function handleRegister() {

    this.handleSubmit(false);

}

const RegistrationFormActions = props =>
    <div className='form-actions'>
        <div>
            {props.isUpdateRegistration ?
                <button
                    className='primary'
                    disabled={props.isDisabled}
                    onClick={props::handleSaveExistingRegistration}
                    tabIndex='16'
                    type='button'
                >
                    <FormattedMessage id='UPDATE_REGISTRATION'/>
                </button> :
                <div>
                    {props.isEditRegistration ?
                        <button
                            onClick={props.handleOpenDeleteModal}
                            tabIndex='18'
                            type='button'
                        >
                            <FormattedMessage id='DELETE'/>
                        </button> :
                    null}
                    {hasAccess(props.security, 'PRT', 'PRT_REGISTER_PRODUCT') && hasPermission(props.user.privacy, 'registrationNotAllowed') &&
                    <button
                        disabled={props.isDisabled}
                        onClick={props::handleRegisterAnother}
                        tabIndex='17'
                        type='button'
                    >
                        <FormattedMessage id='REGISTER_PRODUCT_AND_REGISTER_ANOTHER'/>
                    </button>
                    }
                    <button
                        className='primary'
                        disabled={props.isDisabled}
                        onClick={props::handleRegister}
                        tabIndex='16'
                        type='button'
                    >
                        <FormattedMessage id='REGISTER_PRODUCT'/>
                    </button>
                </div>

            }
        </div>
    </div>;

RegistrationFormActions.displayName = 'RegistrationFormActions';
RegistrationFormActions.propTypes = {
    handleOpenDeleteModal: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    isEditRegistration: PropTypes.bool.isRequired,
    isUpdateRegistration: PropTypes.bool.isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default RegistrationFormActions;



// WEBPACK FOOTER //
// ./src/product/product-registration/components/product-registration-form/registration-form-actions.js